<template>
	<ChatHeader
		:isThread="true"
		:title="chat.title || chat.displayname"
		:chatId="chat.id"
	>
		<div class="chat-header-details">
			<div class="chat-header-title" v-if="creator">
				<Mention :user="creator" :isMe="isMe(creator.id)" />
				{{
					t('chat_stream_header_description_thread_created_creator', {
						CreatedDate: createdAt,
					})
				}}
			</div>
			<div class="chat-header-title" v-else>
				{{ t('chat_stream_header_description_thread_created', [createdAt]) }}
			</div>
		</div>
		<div class="chat-header-actions">
			<Button
				link
				class="notification-settings-button"
				@click="openNotificationMenu"
			>
				<BellIcon type="regular" />
				<span>{{ t('chat_stream_header_notifications_button') }}</span>
			</Button>
		</div>
	</ChatHeader>
</template>

<script setup>
import { computed } from 'vue'
import moment from 'moment'
import { getUser, getCurrentChat, getChat, getMyUserId } from '@/store'
import ChatHeader from './ChatHeader'
import { Button } from '@/components/common'
import { BellIcon } from '@/icons'
import { useI18n } from 'vue-i18n'
import Mention from '@/components/Message/Mention'

const props = defineProps({
	chatId: { type: Number, default: null },
})

const { t } = useI18n()

const chat = computed(() => {
	if (props.chatId) {
		return getChat(props.chatId) || {}
	}
	return getCurrentChat()
})

const creator = computed(() => {
	return getUser(chat.value.user_id)
})

const createdAt = computed(() => {
	return moment(chat.value.created_at).local().format('L')
})

function isMe(user_id) {
	return user_id === getMyUserId()
}

function openNotificationMenu() {
	window.EventBus.$emit('open-thread-notification-menu')
}
</script>

<style lang="scss" scoped>
@import 'src/sass/variables';
.chat-header-details {
	color: var(--neutral-800);
	font-family: Avenir-Medium;
	font-size: 17px;
	font-weight: 400;
	margin-top: 10px;
	margin-bottom: 5px;
	span {
		color: var(--blue-300);
		font-weight: 500;
		font-family: Avenir-Roman;
	}
	.chat-header-title {
		font-family: Avenir-Book;
	}
}

.chat-header-actions {
	display: flex;
	gap: 25px;
	.notification-settings-button {
		padding: 0;
		color: var(--teal-300);
		font-size: 17px;
		font-family: Avenir-Roman;
		&:hover {
			color: var(--teal-200) !important;
		}
		.pronto-icon {
			font-size: 18px;
		}
	}
}
</style>
